// extracted by mini-css-extract-plugin
module.exports = {"revoke_permission":"CookieRevoke_revoke_permission__9D-1u"};